// extracted by mini-css-extract-plugin
module.exports = {"button":"ClearFilters_button__9Bjq4","label":"ClearFilters_label__oSxZM"};